import type { EmvGlobalConfigurationDto } from "src/app/features/EmvGlobalConfiguration/types/EmvGlobalConfigurationDto";
import type { EmvGlobalConfigurationEntity } from "src/app/features/EmvGlobalConfiguration/types/EmvGlobalConfigurationEntity";

export const EmvGlobalConfigurationEntityToDto = ({
    capKeysIptFile,
    capKeysOptFile,
    capKeysUnattendedFile,
    ...rest
}: Readonly<EmvGlobalConfigurationEntity>): EmvGlobalConfigurationDto => {
    const deleteCapKeysIptFile = typeof capKeysIptFile === "boolean";
    const deleteCapKeysOptFile = typeof capKeysOptFile === "boolean";
    const deleteCapKeysUnattendedFile = typeof capKeysUnattendedFile === "boolean";

    return { ...rest, deleteCapKeysIptFile, deleteCapKeysOptFile, deleteCapKeysUnattendedFile };
};
